import { createGlobalStyle } from 'styled-components'
import  { globalStyles } from 'twin.macro'
import 'react-notifications/lib/notifications.css';
import "react-datetime/css/react-datetime.css";
import 'bootstrap/dist/css/bootstrap.min.css';

const GlobalStyles = createGlobalStyle(globalStyles, `
   /* Below animations are for modal created using React-Modal */
     .ReactModal__Overlay {
     transition: transform 300ms ease-in-out;
     transition-delay: 100ms;
     transform: scale(0);
   }
   .ReactModal__Overlay--after-open{
     transform: scale(1);
   }
   .ReactModal__Overlay--before-close{
     transform: scale(0);
   }

   .customDropdown{
    background-color: aliceblue;
   }

   .carousel-indicators{
      background-color: transparent;
   }

   .carousel-control-next{
    with: 10%;
   }


`)

export default GlobalStyles